import { render, staticRenderFns } from "./SwivelAddCard.vue?vue&type=template&id=95c07f7e&scoped=true&"
import script from "./SwivelAddCard.vue?vue&type=script&lang=js&"
export * from "./SwivelAddCard.vue?vue&type=script&lang=js&"
import style0 from "./SwivelAddCard.vue?vue&type=style&index=0&id=95c07f7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c07f7e",
  null
  
)

export default component.exports